import React, { useEffect, useRef, useState } from "react";
import ModalPopup from "../../Common/Modal/Modal";
import { toast } from "react-toastify";
import { encryptVaultSecret } from "../../Common/Encrypt-Decrypt";

const DocumentOtpModal = ({
  show,
  onClose,
  document,
  actionType = "download_document",
  onVerifySuccess,
  resendOtp,
}) => {
  const inputRefs = useRef([]);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(300);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!show) return;

    setOtp(["", "", "", "", "", ""]);
    setTimer(300);

    setTimeout(() => {
      inputRefs.current[0]?.focus();
    }, 200);
  }, [show]);

  useEffect(() => {
    if (!show || timer <= 0) return;

    const interval = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [show, timer]);

  const formatTimer = () => {
    const min = String(Math.floor(timer / 60)).padStart(2, "0");
    const sec = String(timer % 60).padStart(2, "0");
    return `${min}:${sec}`;
  };

  const getButtonText = () => {
    if (loading) return "Verifying...";

    if (actionType === "download_document") return "Verify & Download";
    if (actionType === "update_document") return "Verify & Update";
    if (actionType === "delete_document") return "Verify & Delete";
    if (actionType === "make_nonsensitive") {
      return "Verify & Make Non-Sensitive";
    }

    return "Verify";
  };

  const handleChange = (index, value) => {
    const digit = value.replace(/\D/g, "").slice(0, 1);

    const updatedOtp = [...otp];
    updatedOtp[index] = digit;
    setOtp(updatedOtp);

    if (digit && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handleResendOtp = async () => {
    if (!document?.document_id || !resendOtp) return;

    const response = await resendOtp(document);

    if (response?.action === "OTP_REQUIRED" || response?.message) {
      toast.success(response?.message || "OTP sent successfully");
      setOtp(["", "", "", "", "", ""]);
      setTimer(300);
      inputRefs.current[0]?.focus();
    }
  };

  const handleVerify = async () => {
    const plainOtp = otp.join("");

    if (plainOtp.length !== 6) {
      toast.error("Enter valid 6 digit OTP");
      return;
    }

    setLoading(true);

    try {
      const encryptedOtp = await encryptVaultSecret(plainOtp);
      await onVerifySuccess?.(encryptedOtp);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalPopup
      show={show}
      onClose={onClose}
      // width="32vw"
      // height="18vw"
      closeicon={false}
    >
      <div className="h-full flex flex-col">
        <div className="flex items-center justify-between">
          <button
            className="bg-[#1f4b7f] text-white pl-4 pr-2 py-1 rounded-r-md back-button"
            onClick={onClose}
          >
            Back
          </button>

          {/* <button
            disabled={timer > 0}
            onClick={handleResendOtp}
            className={`text-[1vw] ${
              timer > 0
                ? "text-[#1F487C] cursor-not-allowed"
                : "text-[#1F487C] cursor-pointer font-bold"
            }`}
          >
            {timer > 0 ? `Resend OTP in ${formatTimer()}` : "Resend OTP"}
          </button> */}
        </div>

        <div className="flex flex-col items-center mt-[1.5vw]">
          <h1 className="text-[#1F487C] text-[1.5vw] font-bold">
            OTP Verification
          </h1>

          <p className="text-[1vw] mt-[1vw] text-black w-[24vw] text-center">
            Enter the 6-digit OTP sent to your registered mobile number.
          </p>

          <div className="flex gap-[0.7vw] mt-[1.2vw]">
            {otp.map((digit, index) => (
              <input
                key={index}
                ref={(el) => (inputRefs.current[index] = el)}
                value={digit}
                maxLength={1}
                onChange={(e) => handleChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                className="w-[2.1vw] h-[2.1vw] text-center text-[1.2vw] border-[#9CA3AF] border-[0.12vw] rounded-[0.35vw] outline-none focus:border-[#1F487C]"
              />
            ))}
          </div>

          <button
            disabled={loading}
            onClick={handleVerify}
            className="bg-[#1F487C] text-white text-[1vw] px-[0.9vw] py-[0.45vw] rounded-[0.4vw] mt-[1vw]"
          >
            {getButtonText()}
          </button>
        </div>
      </div>
    </ModalPopup>
  );
};

export default DocumentOtpModal;